import React, {useEffect}  from 'react';
import NormalBtn from '../StockItems/NormalBtn';
import CodeOutput from './CodeOutput';
import GetContractCode from './GetContractCode';
import MainLaunchPage from './MainLaunchPage';
import AddTime from './AddTime';
import LaunchedAlready from './LaunchedAlready';
import * as CoreFns from '../utilities/CoreFns';

function App(props) {

  var setSelectedStep = props.setSelectedStep;
  var selectedStep = props.selectedStep;
  var currentList = props.currentList;
  var clickBack = props.clickBack;

  var programSetID = props.programSetID;
  var sessionID = props.sessionID;
  var userID = props.userID;
  var signKey = props.signKey;
  var addToExtraScreen = props.addToExtraScreen;
  var width = props.width;
  var nosCredits = props.nosCredits;
  var logInState = props.logInState;
  var setNosCredits = props.setNosCredits;

  var history = props.history;
  var setHistory = props.setHistory;
  var getHistoryWithDefaults = props.getHistoryWithDefaults;
  var height = props.height;
  var accessLevel = props.accessLevel;
  var simplDuplicate = props.simplDuplicate;
  var chains = props.chains;
  var changeTab = props.changeTab;

  var changeShowWhat = props.changeShowWhat;

  useEffect(()=>{
    getHistoryWithDefaults();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
   getHistoryWithDefaults();
  }, [selectedStep]);

  if (!logInState){
    function clickSignIn(){
      addToExtraScreen({t:'signIn'});
    }
    return <NormalBtn onClick={clickSignIn} title='Sign in to Launch' />
//
  }

  var relevantLaunchInfo = CoreFns.getRelevantLaunchInfo(history, programSetID);

  if (!relevantLaunchInfo){
    return <div className="row mb-4">
      <div className="col-lg-10 mx-auto text-center">
        <h4 className="display-4" >Loading...</h4>
        </div></div>
//
  }

  if (selectedStep.length === 1){
    return <MainLaunchPage chains={chains} setSelectedStep={setSelectedStep} currentList={currentList} accessLevel={accessLevel} simplDuplicate={simplDuplicate} changeShowWhat={changeShowWhat} addToExtraScreen={addToExtraScreen} changeTab={changeTab} clickBack={clickBack}/>
  }


  if (selectedStep[1] === 'addTime' || selectedStep[1] === 'launch'){
    var currentUrl = relevantLaunchInfo.v[5].v;

    if (selectedStep[1] === 'launch' && currentUrl){

      return <LaunchedAlready setSelectedStep={setSelectedStep} programSetID={programSetID} sessionID={sessionID} userID={userID} signKey={signKey} setNosCredits={setNosCredits} relevantLaunchInfo={relevantLaunchInfo} history={history} setHistory={setHistory} height={height} addToExtraScreen={addToExtraScreen} currentList={currentList} nosCredits={nosCredits} clickBack={clickBack}/>

    }


    return <AddTime fromWhere={selectedStep[1]} programSetID={programSetID} sessionID={sessionID} userID={userID} signKey={signKey} nosCredits={nosCredits} setNosCredits={setNosCredits} clickBack={clickBack} relevantLaunchInfo={relevantLaunchInfo} addToExtraScreen={addToExtraScreen} getHistoryWithDefaults={getHistoryWithDefaults} history={history} setHistory={setHistory} currentList={currentList}/>

  }else if (selectedStep[1] === 'code'){
    return <GetContractCode setSelectedStep={setSelectedStep} programSetID={programSetID} userID={userID} sessionID={sessionID} signKey={signKey} nosCredits={nosCredits} addToExtraScreen={addToExtraScreen} currentList={currentList} clickBack={clickBack}/>
  }else if (selectedStep[1] === 'coded'){
    return <CodeOutput width={width} code={selectedStep[2]} programSetID={programSetID} sessionID={sessionID} signKey={signKey} setSelectedStep={setSelectedStep} userID={userID} nosCredits={nosCredits} setNosCredits={setNosCredits} addToExtraScreen={addToExtraScreen} clickBack={clickBack}/>
  }

}


export default App;
